import * as React from 'react';
import { useTheme } from '@/themes';
import { env } from '@zopauk/nextjs-env';
import { useProfile } from '@/components/Form/hooks';
import { useSession, logout, login } from '@zopauk/nextjs-auth';
import { Navbar as ZopaNavbar, NavbarLite } from '@zopauk/react-components';
import type { NavbarProps } from '@zopauk/react-components/types/components/organisms/Navbar/Navbar/Navbar';

// Import any theme logos here
// TODO: Generalise this function and the Navbar so it doesn't require copy pasting
import JohnLewisLogo from '@/themes/jl-money/logo';

export interface NavbarStateProps extends NavbarProps {
  routes: Record<'userProfile', string>;
}

const routes = {
  userProfile: `${env('NEXT_PUBLIC_HUB_DOMAIN')}/profile`,
} as const;

// TODO: This Component is causing a hydration error

// TODO: Refactor this to use Theming V2 features

export const Navbar = () => {
  const { data } = useProfile();
  const { data: session } = useSession();
  const { partnerName } = useTheme();
  const [isCobranded, setIsCobranded] = React.useState(false);

  React.useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setIsCobranded(window.location.href.includes('sorry') || window.location.href.includes('cancelled'));
  }, []);

  // Themed variants have no auth as of Dec 2024
  if (partnerName === 'jl-money') {
    return (
      <NavbarLite isCobranded={isCobranded}>
        <JohnLewisLogo />
      </NavbarLite>
    );
  }

  const zopaNavItems = session
    ? [
        {
          children: [
            { href: routes.userProfile, label: 'My Details' },
            {
              onClick: logout,
              label: 'Logout',
            },
          ],
          label: data?.firstName,
        },
      ]
    : undefined;
  return (
    <ZopaNavbar
      cta={
        !session ? (
          <ZopaNavbar.Action data-automation="ZA.navbar-signin" onClick={() => login()}>
            Sign in
          </ZopaNavbar.Action>
        ) : null
      }
      links={zopaNavItems}
      withCTA={!session}
    />
  );
};
